
















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Search, Toast } from 'vant';
Vue.use(Search);
@Component
export default class FormSearchInput extends Vue {
  // @Prop() dataList!: string[];
  @Prop() title!: string;
  @Prop() placeholder!: string;
  @Prop() color!: string;
  @Prop() apiFn!: any;
  dataBoxShow = false;
  value: string = '';
  searchValue: string = '';
  renderList: string[] = [];

  // mounted() {
  //   this.$nextTick(() => {
  //     document.addEventListener('click', this._cancleShowBox);
  //   });
  // }
  // 开始选择
  handleClickSelect() {
    this.dataBoxShow = !this.dataBoxShow;
  }
  onChange(val: string) {
    if (typeof this.apiFn === 'function') {
      this.apiFn(val).then((res: any) => {
        if (res.code === 200) {
          let suffix = '';
          this.renderList = res.data.map((item: any) => {
            // 判断条件
            suffix =
              item.schoolname.indexOf('-') >= 0
                ? item.schoolname
                : item.countname + '---' + item.schoolname;
            return suffix;
          });
        }
      });
    }
  }
  confirmVal() {
    this.value = this.searchValue;
    this.dataBoxShow = false;
  }
  // onSearch() {
  //   if (!this.searchValue) {
  //     Toast('请输入关键字');
  //     return;
  //   }
  //   this.renderList = this.dataList.filter((item, index) => {
  //     return item.indexOf(this.searchValue) !== -1;
  //   });
  // }

  handleClickConfrim(value: string) {
    this.dataBoxShow = false;
    this.value = value;
  }
  @Watch('value')
  onValueChange() {
    console.log(this.value);
    this.$emit('selectData', this.value);
  }

  _cancleShowBox(e: any) {
    if (this.dataBoxShow) {
      if (e.target.className !== 'FormSearchInput') {
        this.dataBoxShow = false;
      }
    }
  }
}
